import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import {makeStyles} from '@material-ui/core/styles';

const AutoStreamTrackAddDialog = ({
                                      isDialogVisible, dialogCloseHandler, handleAddTrackFile, newRecordFileUrl, handleAutoTrackUrlChange,
                                      newRecordFile, trackByUrlName, handleTrackByUrlNameChange, getNewRecordDurationRepresent, playAudio,
                                      pauseAudio, handleNewRecordAdd, uploadingFile
                                  }) => {
    const classes = useStyles();

    return (
        <Dialog
            open={isDialogVisible}
            onClose={dialogCloseHandler}
            aria-labelledby='auto-stream-add-track-dialog-title'
            aria-describedby='auto-stream-add-track-dialog-description'
            fullWidth
        >
            <DialogTitle id='auto-stream-add-track-dialog-title'>{'Загрузка трека для автострима'}</DialogTitle>
            <DialogContent>
                <List id='auto-stream-add-track-dialog-description'>
                    <ListItem classes={{gutters: classes.chooseTrackItem}}>
                        <input
                            id='text-button-auto-stream-add-track'
                            accept='.mp3'
                            className={classes.input}
                            multiple
                            type='file'
                            onChange={handleAddTrackFile}
                        />
                        <label htmlFor='text-button-auto-stream-add-track'>
                            <Button component={'span'} color={'primary'}>
                                Выбрать трек
                            </Button>
                        </label>
                    </ListItem>
                    <ListItem classes={{gutters: classes.listItem}}>
                        <TextField
                            fullWidth
                            label='Добавить по URL'
                            type='url'
                            value={newRecordFileUrl}
                            onChange={handleAutoTrackUrlChange}
                        />
                    </ListItem>
                    <ListItem classes={{gutters: classes.listItem}}>
                        <audio src={newRecordFile && newRecordFile.name || ''}/>
                        <TextField
                            label='Наименование трека'
                            disabled={!newRecordFileUrl}
                            required
                            type='text'
                            value={newRecordFile && newRecordFile.name || newRecordFileUrl && trackByUrlName}
                            className={classes.trackByUrlField}
                            onChange={handleTrackByUrlNameChange}
                        />
                        <TextField
                            label='Длительность трека'
                            disabled={true}
                            type='text'
                            value={getNewRecordDurationRepresent()}
                        />
                        <Button
                            disabled={!newRecordFile && !newRecordFileUrl}
                            onClick={() => playAudio(newRecordFileUrl || URL.createObjectURL(newRecordFile))}
                        >
                            Play
                        </Button>
                        <Button disabled={!newRecordFile && !newRecordFileUrl} onClick={pauseAudio}>Stop</Button>
                    </ListItem>
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    pauseAudio();
                    dialogCloseHandler();
                }} color='primary'>
                    Отмена
                </Button>
                <Button
                    disabled={(!newRecordFile && !newRecordFileUrl) || uploadingFile || (!newRecordFile && newRecordFileUrl && !trackByUrlName)}
                    onClick={() => {
                        pauseAudio();
                        handleNewRecordAdd();
                        dialogCloseHandler();
                    }}
                    color={'secondary'}
                >
                    Продолжить
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const useStyles = makeStyles({
    trackByUrlField: {
        marginRight: 15,
        width: 180,
        minWidth: 180
    },
    input: {
        display: 'none'
    },
    chooseTrackItem: {
        padding: 0
    },
    listItem: {
        paddingLeft: 8,
        paddingRight: 8
    }
});

export default AutoStreamTrackAddDialog;
